import { render } from "./DocumentName.vue?vue&type=template&id=605ff746&scoped=true"
import script from "./DocumentName.vue?vue&type=script&lang=js"
export * from "./DocumentName.vue?vue&type=script&lang=js"

import "../../assets/scss/document_name.scss?vue&type=style&index=0&id=605ff746&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605ff746"]])

export default __exports__